import Histogram from './histogram';

export default {
  Histogram,
};
